module.exports = __webpack_public_path__ + "img/icon-faq-minus.4cc2cc25.svg";